import { useTranslation } from 'react-i18next'

import { useSpotlightedOrgs } from '../useSpotlightedOrgs/useSpotlightedOrgs'

export const useSpotlightedBadge = (organisationId?: string | null) => {
  const { t } = useTranslation()
  const { isOrgSpotlighted, partnerLogo, partnerName } = useSpotlightedOrgs()

  const isSpotlighted = !!organisationId && isOrgSpotlighted(organisationId)
  const spotlightedBadge = isSpotlighted && partnerLogo ? partnerLogo : null
  const spotlightedBadgeTooltip = spotlightedBadge
    ? t('workplace_giving.common.spotlightedOrganisation', { partnerName })
    : null

  return {
    spotlightedBadge,
    spotlightedBadgeTooltip
  }
}
